import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useSearchParams } from "react-router";
import { SubNav } from "../components/SubNav";
import Adjustments from "./payroll/Adjustments";
import Gratuity from "./payroll/Gratuity";
import Runs from "./payroll/Runs";
import { usePeopleCompany } from "./People";

/** Payroll depth (WP-24 wave Q, HRX-07).
 *
 * Payroll here already runs and is statutorily shaped: 593 submitted slips across six months, with INSS, INPP,
 * ONEM and a progressive IPR slab. What was missing is the depth around it — end-of-service indemnity that
 * could not be computed at all, six months without a single correction, IPR charged with no relief, and a
 * payroll that does not read the attendance wave K started recording.
 *
 * Every rate and slab on these screens is indicative: it carries the shape of DRC practice so the mechanism can
 * be exercised, and the numbers belong to WP-16. The screens say so. */

export const PAYROLL_SCREENS = ["gratuity", "adjustments"] as const;

export default function Payroll() {
  const { t } = useTranslation();
  const company = usePeopleCompany();
  const [params] = useSearchParams();
  const query = params.get("company") ? `?company=${encodeURIComponent(params.get("company")!)}` : "";

  const items = [
    { key: "runs", to: `/people/payroll${query}`, label: t("pay.tabs.runs"), end: true },
    ...PAYROLL_SCREENS.map((k) => ({ key: k, to: `/people/payroll/${k}${query}`, label: t(`pay.tabs.${k}`) })),
  ];

  return (
    <div data-payroll>
      <SubNav items={items} label={t("pay.sections")} />
      <Outlet context={{ company }} />
    </div>
  );
}

const useCompany = () => useOutletContext<{ company: string }>().company;

export const PayrollIndex = () => <Runs company={useCompany()} />;
export const PayrollGratuity = () => <Gratuity company={useCompany()} />;
export const PayrollAdjustments = () => <Adjustments company={useCompany()} />;
